import React from 'react';

export default function Placeholder({ title }) {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center space-y-8">
      <p className="text-kin-gold tracking-[0.3em] text-sm uppercase font-light">
        Ecosystem Architecture
      </p>
      <h1 className="text-4xl md:text-6xl font-serif text-kin-ivory capitalize">
        {title}
      </h1>
      <p className="text-kin-ivory/50 font-light tracking-wide">
        This premium section is ready for content injection.
      </p>
    </div>
  );
}